"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
require("./Button.scss");
const Button_scss_json_1 = __importDefault(require("./Button.scss.json"));
const useButton_1 = require("@mui/base/useButton");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
exports.Button = react_1.default.forwardRef(function CustomButton(props, ref) {
    // props = useStyles(props, style.ButtonRoot);
    const { children, disabled, variant = 'filled', color = 'primary', fullWidth = false, startIcon, endIcon, } = props;
    const { active, focusVisible, getRootProps } = (0, useButton_1.useButton)(Object.assign(Object.assign({}, props), { rootRef: ref }));
    return (react_1.default.createElement("button", Object.assign({}, getRootProps(), { className: (0, ClassNames_1.cl)(props.className, Button_scss_json_1.default.ButtonRoot, Button_scss_json_1.default[variant], color && Button_scss_json_1.default[color], disabled && Button_scss_json_1.default['disabled'], active && Button_scss_json_1.default['active'], focusVisible && Button_scss_json_1.default['focusVisible'], fullWidth && Button_scss_json_1.default['fullwidth']) }),
        startIcon && startIcon,
        children,
        endIcon && endIcon));
});
//# sourceMappingURL=Button.js.map